import { LoginService } from 'application/services/login'
import { api } from 'infra/adapters/http-client-adapter'

export const handleLogin = new LoginService(api)
